import { render, staticRenderFns } from "./ChartsStatisticDay.vue?vue&type=template&id=44fa0b1f&"
import script from "./ChartsStatisticDay.vue?vue&type=script&lang=js&"
export * from "./ChartsStatisticDay.vue?vue&type=script&lang=js&"
import style0 from "./ChartsStatisticDay.vue?vue&type=style&index=0&id=44fa0b1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports